export const AWS_REGION_OPTIONS = [
  { value: 'frankfurt', label: 'Frankfurt (eu-central-1)' },
  { value: 'ireland', label: 'Ireland (eu-west-1)' },
  { value: 'paris', label: 'Paris (eu-west-3)' },
  { value: 'london', label: 'London (eu-west-2)' },
  { value: 'stockholm', label: 'Stockholm (eu-north-1)' },
  { value: 'eu-north-1', label: 'EU North 1 (eu-north-1, Alias)' },
  { value: 'ohio', label: 'Ohio (us-east-2)' },
  { value: 'oregon', label: 'Oregon (us-west-2)' },
];

/** Regionen die im Multi-Campaign / Fast-Prepare Pfad nicht rotieren dürfen */
export const MULTI_CAMPAIGN_EXCLUDED_AWS_REGIONS = [
  'frankfurt',
  'oregon',
  'stockholm',
  'eu-north-1',
];

const EXCLUDED_AWS_REGION_SET = new Set(MULTI_CAMPAIGN_EXCLUDED_AWS_REGIONS);

export const DEFAULT_AWS_REGIONS = AWS_REGION_OPTIONS.map((option) => option.value);

export const MULTI_CAMPAIGN_DEFAULT_AWS_REGIONS = DEFAULT_AWS_REGIONS.filter(
  (region) => !EXCLUDED_AWS_REGION_SET.has(region),
);

export function sanitizeAwsRegions(regions) {
  const filtered = Array.isArray(regions)
    ? regions.filter((region) => !EXCLUDED_AWS_REGION_SET.has(region))
    : [];
  return filtered.length > 0
    ? filtered
    : [...MULTI_CAMPAIGN_DEFAULT_AWS_REGIONS];
}

export function resolveAwsRegionFromConfig(cfg, segIdx = 0) {
  const pool = Array.isArray(cfg?.regions) && cfg.regions.length > 0
    ? sanitizeAwsRegions(cfg.regions)
    : (cfg?.region && !EXCLUDED_AWS_REGION_SET.has(cfg.region)
      ? [cfg.region]
      : MULTI_CAMPAIGN_DEFAULT_AWS_REGIONS);
  return pool[segIdx % pool.length];
}

export function pickAwsRegionsFromLinkTypes(linkConfig, types) {
  for (const type of types) {
    const cfg = linkConfig?.[type];
    if (Array.isArray(cfg?.regions) && cfg.regions.length > 0) {
      return sanitizeAwsRegions(cfg.regions);
    }
    if (cfg?.region && !EXCLUDED_AWS_REGION_SET.has(cfg.region)) {
      return [cfg.region];
    }
  }
  return [...MULTI_CAMPAIGN_DEFAULT_AWS_REGIONS];
}
